export const SELECTION_TYPES = {
  COLUMN: 'SELECTION.COLUMN',
  DAY_TEMPLATE: 'SELECTION.DAY_TEMPLATE',
};
